import { INotificationOptions } from '../domain/entities/Notification/Notification';

export interface INotificationError {
  message: string;
  notification: INotificationOptions;
}

export default class NotificationError extends Error implements INotificationError {
  public notification: INotificationOptions;

  constructor(notification: INotificationOptions) {
    super(notification.key);
    this.notification = notification;
  }
}